import PropTypes from 'prop-types';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import useVersionInfo from '../hooks/useVersionInfo';
const defaultVersionInfo = {
    be: [],
    fe: []
};
export const VersionInfoContext = /*#__PURE__*/ createContext({
    versionInfo: defaultVersionInfo
});
export const VersionInfoLazyProvider = ({ children })=>{
    const [versionInfo, setVersionInfo] = useState(defaultVersionInfo);
    const versionInfoValue = useMemo(()=>({
            versionInfo,
            setVersionInfo
        }), [
        versionInfo
    ]);
    return /*#__PURE__*/ React.createElement(VersionInfoContext.Provider, {
        value: versionInfoValue
    }, children);
};
VersionInfoLazyProvider.propTypes = {
    children: PropTypes.node
};
export const VersionInfoInitializer = (props)=>{
    const versionInfoContext = useContext(VersionInfoContext);
    const versionInfo = useVersionInfo(props);
    useEffect(()=>{
        if (versionInfo && JSON.stringify(versionInfoContext.versionInfo) !== JSON.stringify(versionInfo)) {
            versionInfoContext.setVersionInfo(versionInfo);
        }
    }, [
        versionInfoContext,
        versionInfo
    ]);
    return /*#__PURE__*/ React.createElement("div", null);
};
